module.exports = __webpack_public_path__ + "static/externat-logo-175x114-7be14028baa68ee80154ae437171cdee.png";